export function contactsById(items = []) {
  return Object.fromEntries(items.map(contact => [contact.id, contact]));
}

export function filterCustomerContacts(items = [], keyword = '') {
  const normalizedKeyword = keyword.trim().toLowerCase();
  return items.filter(contact => {
    if (!normalizedKeyword) {
      return true;
    }
    return [
      contact.name,
      contact.company,
      contact.country,
      contact.notes,
      ...(contact.tags || []),
      ...(contact.platforms || []),
    ].some(value => String(value || '').toLowerCase().includes(normalizedKeyword));
  });
}
